var _defs, _path, _text;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconsBenefitKommunikation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 34.02 34.02",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: none;\n        stroke: #defc70;\n        stroke-miterlimit: 10;\n        stroke-width: 1.3px;\n      }\n\n      .st1 {\n        fill: #fff;\n        font-family: DINPro-Regular, DINPro;\n        font-size: 14.07px;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M21.36,22.77h-9.23M23.59,4.97v8.18h.02s5.25-4.08,5.25-4.08v-.02s-5.25-4.09-5.25-4.09h-.02ZM10.43,20.86v8.18h-.02s-5.25-4.08-5.25-4.08v-.02s5.25-4.09,5.25-4.09h.02ZM12.13,27.13h9.33c3.27,0,5.28-1.7,5.28-4.59.29-3.03-2.09-5.59-5.06-5.59h-9.46c-3.27,0-5.28-2.26-5.28-4.59-.29-3.03,2.09-5.59,5.06-5.59h9.54M21.54,11.34h-9.8"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    className: "st1",
    transform: "translate(28.37 22.23)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsBenefitKommunikation);
export default __webpack_public_path__ + "static/media/Icons_Benefit_Kommunikation.09d0864df13b6327ec91918132c0d9d1.svg";
export { ForwardRef as ReactComponent };